import {
  ColorsNeutral150,
  ColorsNeutral400,
  Dimensions2,
  Dimensions4,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const table = css({
  '.MuiTableBody-root .MuiTableRow-root:hover': {
    backgroundColor: ColorsNeutral150,
  },
  '.MuiTableCell-root': {
    border: 'none',
    padding: `${Dimensions2} ${Dimensions4}`,
  },
});

const head = css({
  '&.MuiTableHead-root': {
    backgroundColor: 'transparent',
  },
});

const headCell = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral400,
  },
});

const profileChip = css({
  '&.MuiChip-root': {
    backgroundColor: 'transparent !important',
    fontSize: '12px',
  },
});

const statusChip = css({
  '&.MuiChip-root': {
    fontSize: '12px',
  },
});

const MembersTableStyles = {
  table,
  head,
  headCell,
  profileChip,
  statusChip,
};

export default MembersTableStyles;
